import React, {useEffect, useState, Fragment} from 'react';
import EventEmitter from '../../../utils/emmiter';
import {postApi} from '../../../utils/functions';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';

import './audioplayer.css';

const AudioPlayer = (props) => {
	//console.log(props.player);
	const [status, setStatus] = useState(false);
	const [metaClubbers, setMetaClubbers] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	const [metaRadio, setMetaRadio] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});

	var [stream, setStream] = useState(null);
	const [channel, setChannel] = useState('Clubbers');
	//const [nowplaying, setNowplaying] = useState({connected_butt: false, connected_obs: false, dj: '', artist: '', title: ''});
	const [isPlaying, setIsPlaying] = useState(false);
	const [showVolume, setShowVolume] = useState(0);
	const [volume, setVolume] = useState(100);
	const [mute, setMute] = useState(0);

	

	useEffect(() => {
		/*EventEmitter.addListener('/header/audioplayer', async data => {
			if( isPlaying ) {
				
				if(data.channel!==isPlaying) {
					console.log(data.channel,isPlaying);
					console.log(Object.keys(data).length, data);
				}
			}
		});*/

		EventEmitter.addListener('/clubbers/meta', async data => {
			setMetaClubbers(data.azura);
		});
		EventEmitter.addListener('/radio/meta', async data => {
			setMetaRadio(data.azura);
		});
	
		EventEmitter.addListener('/audio/controls', async data => {
			//setMetaRadio(data.azura);
			
			//console.log(data);

			if( data.play && !props.mobile) {
				//console.log("play!");
				//await OnPlay('');
				//console.log(stream);
				if( stream ) {
					stream.pause();
					stream.currentTime = 0;
					stream.src="";
				}
				setTimeout(()=>{
					OnPlay(data.channel);
				},200);
			}
			if( data.stop ) {
				//console.log("stop!");
			}
			if( data.mute ) {
				//console.log("mute!");
			}

		});

		async function loadMeta() {
			var params = new URLSearchParams();
			const x = await postApi('/api/v2/nowplaying', params);
			if( Object.keys(x.data.Clubbers).length > 0 ) setMetaClubbers(x.data.Clubbers);
			if( Object.keys(x.data.Radio).length > 0 ) setMetaRadio(x.data.Radio);
		}
		if( status === false ) {
			setStatus(true);
			loadMeta();
		}
	},[]);

	function setAudio(channel) {
		setChannel(channel);
	}

	function OnPlay(channel) {
		let url = channel==='clubbers'?'https://cloud.mix365.co.uk:8005/radio.mp3':'https://cloud.mix365.co.uk:4435/listen/365radio/radio.mp3';
		if( stream === null ) {
			let song = new Audio( url );
			song.play();
			setStream( song );
			setIsPlaying(`/audio/${channel}`);
			
			//setTimeout(()=>{setIsPlaying(channel);},2000);
			/*setTimeout(()=>{
				EventEmitter.emit('/header/audioplayer', {channel: `/audio/${channel}`});
			},1000);*/
		} else {
			if( stream.paused ) {
				stream.src=url;
				stream.currentTime = 0;
				stream.play();
				setIsPlaying(`/audio/${channel}`);
				/*setTimeout(()=>{
					EventEmitter.emit('/header/audioplayer', {channel: `/audio/${channel}`});
				},1000);*/
			} else {
				stream.pause();
				stream.currentTime = 0;
				stream.src="";
				setIsPlaying(false);
				//setTimeout(()=>{setIsPlaying(false);},2000);
			}
		}
	}

	function audioMute() {
		if( stream.volume === 0 ) {
			stream.volume = Number(volume/100).toFixed(1);
			setMute(0);
		} else {
			stream.volume = 0;
			setMute(1);
		}
	}

	let volumetimer;
	function showVolumeBar(event) {
		if( event === 0 ) {
			volumetimer = setTimeout(()=>{setShowVolume(0)}, 500);
		} else {
			clearTimeout(volumetimer);
			//this.setState({showVolume: event});
			setShowVolume(event);
		}
	}

	function setVolumeBar(event) {
		try{
			if( stream !== null ) {
				let percent = ((event.clientX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width);
				stream.volume = Number(percent).toFixed(1);
				setVolume(Number(percent).toFixed(1)*100);
			}
		} catch(error){console.log(error)}
	}

	//console.log(stream);
	let clubbers = `${metaClubbers.artist} - ${metaClubbers.title}`;
	let radio = `${metaRadio.artist} - ${metaRadio.title}`;
	return (
		<div className="audioplayer">
			

			<Row className="pt-2">
				<div className="text-vcenter" style={{width: 100}}>
					<Dropdown className="d-grid gap-2">
						<Dropdown.Toggle id="dropdown-basic" size="sm" className="audioplayer-outline">
							{channel}
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item onClick={()=>setAudio('Clubbers')}>Clubbers</Dropdown.Item>
							<Dropdown.Item onClick={()=>setAudio('Radio')}>Radio</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>
					{channel === 'Clubbers' ?
						<>
							<div className="text-vcenter" style={{width: 30}}>
								{isPlaying==='/audio/clubbers'?
									<button className="audioplayer-button" aria-controls="mep_0" title="Stop" aria-label="stop" tabIndex="0" onClick={()=>OnPlay('')}>
										<FontAwesomeIcon icon="stop" />
									</button>
									
								:
									<button className="audioplayer-button" aria-controls="mep_0" title="Play" aria-label="Play" tabIndex="0" onClick={()=>OnPlay('clubbers')}>
										<FontAwesomeIcon icon="play" />
									</button>
								}
							</div>
							<Col className="text-vertical">
								{metaClubbers.dj !== '' ?
									<>
										<span className="audioplayer-live">Live</span> {metaClubbers.dj}
										{metaClubbers.artist !== ''&&
											<>, {metaClubbers.artist}</>
										}
										{metaClubbers.title !== ''&&metaClubbers.title !== 'Live Broadcast'&&
											<> - {metaClubbers.title}</>
										}
									</>
								:
									<>{clubbers.substring(0,70)}</>
								}
							</Col>
						</>
					:
						<>
							<div className="text-vcenter" style={{width: 30}}>
								{isPlaying==='/audio/radio'?
									<button className="audioplayer-button" aria-controls="mep_0" title="Stop" aria-label="Stop" tabIndex="0" onClick={()=>OnPlay('')}>
										<FontAwesomeIcon icon="stop" />
									</button>
								:
									<button className="audioplayer-button" aria-controls="mep_0" title="Play" aria-label="Play" tabIndex="0" onClick={()=>OnPlay('radio')}>
										<FontAwesomeIcon icon="play" />
									</button>
								}
							</div>
							<Col className="text-vertical">
								{metaRadio.dj !== '' ?
									<>
										Radio <span className="audioplayer-live">Live</span> {metaRadio.dj}
										{metaRadio.artist !== ''&&
											<>, {metaRadio.artist}</>
										}
										{metaRadio.title !== ''&&metaRadio.title !== 'Live Broadcast'&&
											<> - {metaRadio.title}</>
										}
									</>
								:
									<>{radio.substring(0,70)}</>
								}
							</Col>
						</>
					}
					
				</Row>

			{/*{((props.mobile && isPlaying!=='/audio/radio') || (!props.mobile && isPlaying==='/audio/clubbers') ) &&
				<div className="row">
					<div className="" style={{width: 30}}>
						{isPlaying==='/audio/clubbers'?
							<button className="audioplayer-button" aria-controls="mep_0" title="Stop" aria-label="stop" tabIndex="0" onClick={()=>OnPlay('')}>
								<FontAwesomeIcon icon="stop" />
							</button>
							
						:
							<button className="audioplayer-button" aria-controls="mep_0" title="Play" aria-label="Play" tabIndex="0" onClick={()=>OnPlay('clubbers')}>
								<FontAwesomeIcon icon="play" />
							</button>
						}
					</div>
					<div className="col">
					{metaClubbers.dj !== '' ?
						<>
							Clubbers <span className="audioplayer-live">Live</span> {metaClubbers.dj}
							{metaClubbers.artist !== ''&&
								<>, {metaClubbers.artist}</>
							}
							{metaClubbers.title !== ''&&metaClubbers.title !== 'Live Broadcast'&&
								<> - {metaClubbers.title}</>
							}
						</>
					:
						<>{clubbers.substring(0,70)}</>
					}
					</div>
				</div>
			}
			{isPlaying!=='/audio/clubbers' &&
			{(props.mobile&&!isPlaying)&&<div className="audioplayer-bottom"></div>}
			{((props.mobile && isPlaying!=='/audio/clubbers') || (!props.mobile && isPlaying==='/audio/radio') ) &&
				<div className="row">
					<div className="" style={{width: 30}}>
						{isPlaying==='/audio/radio'?
							<button className="audioplayer-button" aria-controls="mep_0" title="Stop" aria-label="Stop" tabIndex="0" onClick={()=>OnPlay('')}>
								<FontAwesomeIcon icon="stop" />
							</button>
						:
							<button className="audioplayer-button" aria-controls="mep_0" title="Play" aria-label="Play" tabIndex="0" onClick={()=>OnPlay('radio')}>
								<FontAwesomeIcon icon="play" />
							</button>
						}
					</div>
					<div className="col">
					{metaRadio.dj !== '' ?
						<>
							Radio <span className="audioplayer-live">Live</span> {metaRadio.dj}
							{metaRadio.artist !== ''&&
								<>, {metaRadio.artist}</>
							}
							{metaRadio.title !== ''&&metaRadio.title !== 'Live Broadcast'&&
								<> - {metaRadio.title}</>
							}
						</>
					:
						<>{radio.substring(0,70)}</>
					}
					</div>
				</div>
			}

			{/*<div className="audioplayer-controls">
			
				{isPlaying===true?
					<div className="audioplayer-button">
						<button type="button" aria-controls="mep_0" title="Stop" aria-label="stop" tabIndex="0" onClick={OnPlay}>
							<FontAwesomeIcon icon="pause" />
						</button>
					</div>
				:
					<div className="audioplayer-button">
						<button type="button" aria-controls="mep_0" title="Play" aria-label="Play" tabIndex="0" onClick={OnPlay}>
							<FontAwesomeIcon icon="play" />
						</button>
					</div>
				}
					
				{stream!==null&&stream.paused===false&&
					<div className="audioplayer-button" onMouseOver={()=>showVolumeBar(1)} onMouseOut={()=>showVolumeBar(0)}>
						<button type="button" aria-controls="mep_0" title={stream&&stream.volume===0?"Unmute":"Mute"} aria-label="Mute" tabIndex="0" onClick={audioMute}>
							<FontAwesomeIcon icon={mute===1?"volume-xmark":"volume-high"} />
						</button>
						{showVolume===1 &&
							<div className="audioplayer-volume">
								<div className="audioplayer-volume-inner">
									<div className="audioplayer-volume-bar" style={{width: `${volume}%`}}>
									</div>
									<div className="audioplayer-volume-click" onClick={(e)=>setVolumeBar(e)}>
									</div>
								</div>
							</div>
						}
					</div>
				}
				<div className="audioplayer-rail">
					<div>
						{displayNowPlaying()}
					</div>
				</div>
			</div>*/}
		</div>
	)
}

export default AudioPlayer;